var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('column-container',[_c('padded-content',{staticClass:"space-children-inline-wide"},[_c('font-awesome-icon',{attrs:{"icon":"exclamation-triangle"}}),_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }